import { Search, Loader2, X } from 'lucide-react';
import { cn } from '@/lib/utils';
import type {InputHTMLAttributes} from "react";

interface SearchBarProps extends InputHTMLAttributes<HTMLInputElement> {
    isLoading?: boolean;
    onClear?: () => void;
}

export function SearchBar({ className, isLoading, value, onClear, onChange, ...props }: SearchBarProps) {
    return (
        <div className={cn("relative group max-w-full", className)}>
            <Search
                className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-emerald-600 transition-colors"
                size={20}
            />

            <input
                className="w-full bg-slate-100 border-none h-14 pl-12 pr-12 rounded-2xl focus:ring-2 focus:ring-emerald-500/20 focus:bg-white outline-none transition-all placeholder:text-slate-400 font-medium text-slate-900"
                value={value}
                onChange={onChange}
                {...props}
            />

            <div className="absolute right-4 top-1/2 -translate-y-1/2 flex items-center gap-2">
                {value && onClear && (
                    <button
                        onClick={onClear}
                        className="p-1 text-slate-400 hover:text-slate-600 hover:bg-slate-200 rounded-full transition-colors"
                    >
                        <X size={16} />
                    </button>
                )}

                {isLoading && (
                    <Loader2 size={20} className="animate-spin text-emerald-600" />
                )}
            </div>
        </div>
    );
}